// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/* Meeting Statistics Page Styles */

.statistics-page {
  max-width: 1400px;
  margin: 0 auto;
  padding: 20px;
}

.statistics-header {
  margin-bottom: 30px;
}

.statistics-header h1 {
  margin: 0 0 8px;
  color: #333;
  font-size: 28px;
}

.statistics-header p {
  margin: 0;
  color: #666;
}

/* Date Filter */
.date-filter {
  display: flex;
  align-items: center;
  gap: 15px;
  margin-bottom: 20px;
  padding: 15px;
  background: white;
  border-radius: 12px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.date-filter label {
  font-weight: 500;
  color: #333;
}

.date-filter select {
  padding: 8px 15px;
  border: 1px solid #ddd;
  border-radius: 8px;
  font-size: 14px;
  cursor: pointer;
}

/* Stats Grid */
.stats-grid {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.stat-card {
  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);
  color: white;
  padding: 24px;
  border-radius: 12px;
  text-align: center;
}

.stat-card h3 {
  margin: 0 0 10px;
  font-size: 14px;
  font-weight: 500;
  opacity: 0.9;
}

.stat-card .stat-value {
  margin: 0;
  font-size: 36px;
  font-weight: 700;
}

.stat-card.success {
  background: linear-gradient(135deg, #28a745, #20c997);
}

.stat-card.warning {
  background: linear-gradient(135deg, #ffc107, #fd7e14);
}

.stat-card.secondary {
  background: linear-gradient(135deg, #6c757d, #495057);
}

/* Charts Row */
.charts-row {
  display: grid;
  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));
  gap: 20px;
  margin-bottom: 30px;
}

.chart-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.chart-card h3 {
  margin: 0 0 20px;
  color: #333;
  font-size: 18px;
}

/* Pie Chart */
.pie-chart {
  width: 200px;
  height: 200px;
  margin: 0 auto 20px;
}

.pie-chart svg {
  width: 100%;
  height: 100%;
}

.chart-legend {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.legend-item {
  display: flex;
  align-items: center;
  gap: 10px;
  font-size: 14px;
}

.legend-color {
  width: 16px;
  height: 16px;
  border-radius: 4px;
}

.legend-color.completed {
  background: #28a745;
}

.legend-color.scheduled {
  background: #007bff;
}

.legend-color.in-progress {
  background: #ffc107;
}

.legend-color.cancelled {
  background: #dc3545;
}

/* Bar Chart */
.bar-chart {
  display: flex;
  justify-content: space-around;
  align-items: flex-end;
  height: 200px;
  padding-top: 20px;
}

.bar-item {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 5px;
  flex: 1 1;
}

.bar-container {
  width: 30px;
  height: 150px;
  background: #f0f0f0;
  border-radius: 4px;
  display: flex;
  align-items: flex-end;
  overflow: hidden;
}

.bar-fill {
  width: 100%;
  background: linear-gradient(180deg, #667eea, #764ba2);
  border-radius: 4px;
  transition: height 0.3s ease;
  min-height: 2px;
}

.bar-label {
  font-size: 12px;
  color: #666;
}

.bar-value {
  font-size: 12px;
  font-weight: 600;
  color: #333;
}

/* Hosts List */
.hosts-list {
  display: flex;
  flex-direction: column;
  gap: 10px;
}

.host-item {
  display: flex;
  align-items: center;
  gap: 10px;
  padding: 10px;
  background: #f9f9f9;
  border-radius: 8px;
}

.host-rank {
  width: 24px;
  height: 24px;
  background: linear-gradient(135deg, #667eea, #764ba2);
  color: white;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 12px;
  font-weight: 600;
}

.host-name {
  flex: 1 1;
  font-size: 14px;
  color: #333;
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}

.host-count {
  font-weight: 600;
  color: #667eea;
}

/* Completion Rate Card */
.completion-rate-card {
  background: white;
  border-radius: 12px;
  padding: 24px;
  margin-bottom: 30px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.completion-rate-card h3 {
  margin: 0 0 20px;
  color: #333;
  font-size: 18px;
}

.completion-bar {
  height: 30px;
  background: #f0f0f0;
  border-radius: 15px;
  overflow: hidden;
  margin-bottom: 15px;
}

.completion-fill {
  height: 100%;
  background: linear-gradient(90deg, #28a745, #20c997);
  border-radius: 15px;
  transition: width 0.5s ease;
}

.completion-stats {
  display: flex;
  justify-content: space-between;
  font-size: 14px;
  color: #666;
}

/* Recent Meetings */
.recent-meetings {
  background: white;
  border-radius: 12px;
  padding: 24px;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
}

.recent-meetings h3 {
  margin: 0 0 20px;
  color: #333;
  font-size: 18px;
}

/* Table Container (reuse from AdminManagement.css) */
.table-container {
  overflow-x: auto;
}

.data-table {
  width: 100%;
  border-collapse: collapse;
}

.data-table th,
.data-table td {
  padding: 12px 15px;
  text-align: left;
  border-bottom: 1px solid #eee;
}

.data-table th {
  font-weight: 600;
  color: #666;
  font-size: 12px;
  text-transform: uppercase;
  background: #f9f9f9;
}

.data-table tr:hover {
  background: #f9f9f9;
}

/* Status Badges */
.status-badge {
  display: inline-block;
  padding: 4px 10px;
  border-radius: 12px;
  font-size: 12px;
  font-weight: 500;
}

.status-badge.scheduled {
  background: #cce5ff;
  color: #004085;
}

.status-badge.completed {
  background: #d4edda;
  color: #155724;
}

.status-badge.in-progress {
  background: #fff3cd;
  color: #856404;
}

.status-badge.cancelled {
  background: #f8d7da;
  color: #721c24;
}

/* No Data */
.no-data {
  text-align: center;
  padding: 20px;
  color: #999;
  font-size: 14px;
}

/* Error Message */
.error-message {
  background: #fee;
  border: 1px solid #fcc;
  color: #c33;
  padding: 12px;
  border-radius: 8px;
  margin-bottom: 20px;
}

/* Loading */
.admin-loading {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 100vh;
  font-size: 18px;
  color: #666;
}

/* Responsive */
@media (max-width: 768px) {
  .stats-grid {
    grid-template-columns: repeat(2, 1fr);
  }

  .charts-row {
    grid-template-columns: 1fr;
  }

  .bar-chart {
    height: 150px;
  }

  .bar-container {
    width: 20px;
    height: 100px;
  }
}
`, "",{"version":3,"sources":["webpack://./src/pages/admin/MeetingStatistics.css"],"names":[],"mappings":"AAAA,mCAAmC;;AAEnC;EACE,iBAAiB;EACjB,cAAc;EACd,aAAa;AACf;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,SAAS;EACT,WAAW;AACb;;AAEA,gBAAgB;AAChB;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,mBAAmB;EACnB,aAAa;EACb,iBAAiB;EACjB,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;AACb;;AAEA;EACE,iBAAiB;EACjB,sBAAsB;EACtB,kBAAkB;EAClB,eAAe;EACf,eAAe;AACjB;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,6DAA6D;EAC7D,YAAY;EACZ,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,gBAAgB;EAChB,YAAY;AACd;;AAEA;EACE,SAAS;EACT,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA;EACE,qDAAqD;AACvD;;AAEA,eAAe;AACf;EACE,aAAa;EACb,2DAA2D;EAC3D,SAAS;EACT,mBAAmB;AACrB;;AAEA;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,cAAc;AACd;EACE,YAAY;EACZ,aAAa;EACb,mBAAmB;AACrB;;AAEA;EACE,WAAW;EACX,YAAY;AACd;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,kBAAkB;AACpB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,cAAc;AACd;EACE,aAAa;EACb,6BAA6B;EAC7B,qBAAqB;EACrB,aAAa;EACb,iBAAiB;AACnB;;AAEA;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,QAAQ;EACR,SAAO;AACT;;AAEA;EACE,WAAW;EACX,aAAa;EACb,mBAAmB;EACnB,kBAAkB;EAClB,aAAa;EACb,qBAAqB;EACrB,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,qDAAqD;EACrD,kBAAkB;EAClB,4BAA4B;EAC5B,eAAe;AACjB;;AAEA;EACE,eAAe;EACf,WAAW;AACb;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,WAAW;AACb;;AAEA,eAAe;AACf;EACE,aAAa;EACb,sBAAsB;EACtB,SAAS;AACX;;AAEA;EACE,aAAa;EACb,mBAAmB;EACnB,SAAS;EACT,aAAa;EACb,mBAAmB;EACnB,kBAAkB;AACpB;;AAEA;EACE,WAAW;EACX,YAAY;EACZ,qDAAqD;EACrD,YAAY;EACZ,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,SAAO;EACP,eAAe;EACf,WAAW;EACX,gBAAgB;EAChB,uBAAuB;EACvB,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,cAAc;AAChB;;AAEA,yBAAyB;AACzB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,mBAAmB;EACnB,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,YAAY;EACZ,mBAAmB;EACnB,mBAAmB;EACnB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,YAAY;EACZ,oDAAoD;EACpD,mBAAmB;EACnB,2BAA2B;AAC7B;;AAEA;EACE,aAAa;EACb,8BAA8B;EAC9B,eAAe;EACf,WAAW;AACb;;AAEA,oBAAoB;AACpB;EACE,iBAAiB;EACjB,mBAAmB;EACnB,aAAa;EACb,wCAAwC;AAC1C;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;AACjB;;AAEA,qDAAqD;AACrD;EACE,gBAAgB;AAClB;;AAEA;EACE,WAAW;EACX,yBAAyB;AAC3B;;AAEA;;EAEE,kBAAkB;EAClB,gBAAgB;EAChB,6BAA6B;AAC/B;;AAEA;EACE,gBAAgB;EAChB,WAAW;EACX,eAAe;EACf,yBAAyB;EACzB,mBAAmB;AACrB;;AAEA;EACE,mBAAmB;AACrB;;AAEA,kBAAkB;AAClB;EACE,qBAAqB;EACrB,iBAAiB;EACjB,mBAAmB;EACnB,eAAe;EACf,gBAAgB;AAClB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,mBAAmB;EACnB,cAAc;AAChB;;AAEA,YAAY;AACZ;EACE,kBAAkB;EAClB,aAAa;EACb,WAAW;EACX,eAAe;AACjB;;AAEA,kBAAkB;AAClB;EACE,gBAAgB;EAChB,sBAAsB;EACtB,WAAW;EACX,aAAa;EACb,kBAAkB;EAClB,mBAAmB;AACrB;;AAEA,YAAY;AACZ;EACE,aAAa;EACb,uBAAuB;EACvB,mBAAmB;EACnB,aAAa;EACb,eAAe;EACf,WAAW;AACb;;AAEA,eAAe;AACf;EACE;IACE,qCAAqC;EACvC;;EAEA;IACE,0BAA0B;EAC5B;;EAEA;IACE,aAAa;EACf;;EAEA;IACE,WAAW;IACX,aAAa;EACf;AACF","sourcesContent":["/* Meeting Statistics Page Styles */\r\n\r\n.statistics-page {\r\n  max-width: 1400px;\r\n  margin: 0 auto;\r\n  padding: 20px;\r\n}\r\n\r\n.statistics-header {\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.statistics-header h1 {\r\n  margin: 0 0 8px;\r\n  color: #333;\r\n  font-size: 28px;\r\n}\r\n\r\n.statistics-header p {\r\n  margin: 0;\r\n  color: #666;\r\n}\r\n\r\n/* Date Filter */\r\n.date-filter {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 15px;\r\n  margin-bottom: 20px;\r\n  padding: 15px;\r\n  background: white;\r\n  border-radius: 12px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.date-filter label {\r\n  font-weight: 500;\r\n  color: #333;\r\n}\r\n\r\n.date-filter select {\r\n  padding: 8px 15px;\r\n  border: 1px solid #ddd;\r\n  border-radius: 8px;\r\n  font-size: 14px;\r\n  cursor: pointer;\r\n}\r\n\r\n/* Stats Grid */\r\n.stats-grid {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(180px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.stat-card {\r\n  background: linear-gradient(135deg, #667eea 0%, #764ba2 100%);\r\n  color: white;\r\n  padding: 24px;\r\n  border-radius: 12px;\r\n  text-align: center;\r\n}\r\n\r\n.stat-card h3 {\r\n  margin: 0 0 10px;\r\n  font-size: 14px;\r\n  font-weight: 500;\r\n  opacity: 0.9;\r\n}\r\n\r\n.stat-card .stat-value {\r\n  margin: 0;\r\n  font-size: 36px;\r\n  font-weight: 700;\r\n}\r\n\r\n.stat-card.success {\r\n  background: linear-gradient(135deg, #28a745, #20c997);\r\n}\r\n\r\n.stat-card.warning {\r\n  background: linear-gradient(135deg, #ffc107, #fd7e14);\r\n}\r\n\r\n.stat-card.secondary {\r\n  background: linear-gradient(135deg, #6c757d, #495057);\r\n}\r\n\r\n/* Charts Row */\r\n.charts-row {\r\n  display: grid;\r\n  grid-template-columns: repeat(auto-fit, minmax(300px, 1fr));\r\n  gap: 20px;\r\n  margin-bottom: 30px;\r\n}\r\n\r\n.chart-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.chart-card h3 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n/* Pie Chart */\r\n.pie-chart {\r\n  width: 200px;\r\n  height: 200px;\r\n  margin: 0 auto 20px;\r\n}\r\n\r\n.pie-chart svg {\r\n  width: 100%;\r\n  height: 100%;\r\n}\r\n\r\n.chart-legend {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.legend-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  font-size: 14px;\r\n}\r\n\r\n.legend-color {\r\n  width: 16px;\r\n  height: 16px;\r\n  border-radius: 4px;\r\n}\r\n\r\n.legend-color.completed {\r\n  background: #28a745;\r\n}\r\n\r\n.legend-color.scheduled {\r\n  background: #007bff;\r\n}\r\n\r\n.legend-color.in-progress {\r\n  background: #ffc107;\r\n}\r\n\r\n.legend-color.cancelled {\r\n  background: #dc3545;\r\n}\r\n\r\n/* Bar Chart */\r\n.bar-chart {\r\n  display: flex;\r\n  justify-content: space-around;\r\n  align-items: flex-end;\r\n  height: 200px;\r\n  padding-top: 20px;\r\n}\r\n\r\n.bar-item {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 5px;\r\n  flex: 1;\r\n}\r\n\r\n.bar-container {\r\n  width: 30px;\r\n  height: 150px;\r\n  background: #f0f0f0;\r\n  border-radius: 4px;\r\n  display: flex;\r\n  align-items: flex-end;\r\n  overflow: hidden;\r\n}\r\n\r\n.bar-fill {\r\n  width: 100%;\r\n  background: linear-gradient(180deg, #667eea, #764ba2);\r\n  border-radius: 4px;\r\n  transition: height 0.3s ease;\r\n  min-height: 2px;\r\n}\r\n\r\n.bar-label {\r\n  font-size: 12px;\r\n  color: #666;\r\n}\r\n\r\n.bar-value {\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n  color: #333;\r\n}\r\n\r\n/* Hosts List */\r\n.hosts-list {\r\n  display: flex;\r\n  flex-direction: column;\r\n  gap: 10px;\r\n}\r\n\r\n.host-item {\r\n  display: flex;\r\n  align-items: center;\r\n  gap: 10px;\r\n  padding: 10px;\r\n  background: #f9f9f9;\r\n  border-radius: 8px;\r\n}\r\n\r\n.host-rank {\r\n  width: 24px;\r\n  height: 24px;\r\n  background: linear-gradient(135deg, #667eea, #764ba2);\r\n  color: white;\r\n  border-radius: 50%;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  font-size: 12px;\r\n  font-weight: 600;\r\n}\r\n\r\n.host-name {\r\n  flex: 1;\r\n  font-size: 14px;\r\n  color: #333;\r\n  overflow: hidden;\r\n  text-overflow: ellipsis;\r\n  white-space: nowrap;\r\n}\r\n\r\n.host-count {\r\n  font-weight: 600;\r\n  color: #667eea;\r\n}\r\n\r\n/* Completion Rate Card */\r\n.completion-rate-card {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  margin-bottom: 30px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.completion-rate-card h3 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n.completion-bar {\r\n  height: 30px;\r\n  background: #f0f0f0;\r\n  border-radius: 15px;\r\n  overflow: hidden;\r\n  margin-bottom: 15px;\r\n}\r\n\r\n.completion-fill {\r\n  height: 100%;\r\n  background: linear-gradient(90deg, #28a745, #20c997);\r\n  border-radius: 15px;\r\n  transition: width 0.5s ease;\r\n}\r\n\r\n.completion-stats {\r\n  display: flex;\r\n  justify-content: space-between;\r\n  font-size: 14px;\r\n  color: #666;\r\n}\r\n\r\n/* Recent Meetings */\r\n.recent-meetings {\r\n  background: white;\r\n  border-radius: 12px;\r\n  padding: 24px;\r\n  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);\r\n}\r\n\r\n.recent-meetings h3 {\r\n  margin: 0 0 20px;\r\n  color: #333;\r\n  font-size: 18px;\r\n}\r\n\r\n/* Table Container (reuse from AdminManagement.css) */\r\n.table-container {\r\n  overflow-x: auto;\r\n}\r\n\r\n.data-table {\r\n  width: 100%;\r\n  border-collapse: collapse;\r\n}\r\n\r\n.data-table th,\r\n.data-table td {\r\n  padding: 12px 15px;\r\n  text-align: left;\r\n  border-bottom: 1px solid #eee;\r\n}\r\n\r\n.data-table th {\r\n  font-weight: 600;\r\n  color: #666;\r\n  font-size: 12px;\r\n  text-transform: uppercase;\r\n  background: #f9f9f9;\r\n}\r\n\r\n.data-table tr:hover {\r\n  background: #f9f9f9;\r\n}\r\n\r\n/* Status Badges */\r\n.status-badge {\r\n  display: inline-block;\r\n  padding: 4px 10px;\r\n  border-radius: 12px;\r\n  font-size: 12px;\r\n  font-weight: 500;\r\n}\r\n\r\n.status-badge.scheduled {\r\n  background: #cce5ff;\r\n  color: #004085;\r\n}\r\n\r\n.status-badge.completed {\r\n  background: #d4edda;\r\n  color: #155724;\r\n}\r\n\r\n.status-badge.in-progress {\r\n  background: #fff3cd;\r\n  color: #856404;\r\n}\r\n\r\n.status-badge.cancelled {\r\n  background: #f8d7da;\r\n  color: #721c24;\r\n}\r\n\r\n/* No Data */\r\n.no-data {\r\n  text-align: center;\r\n  padding: 20px;\r\n  color: #999;\r\n  font-size: 14px;\r\n}\r\n\r\n/* Error Message */\r\n.error-message {\r\n  background: #fee;\r\n  border: 1px solid #fcc;\r\n  color: #c33;\r\n  padding: 12px;\r\n  border-radius: 8px;\r\n  margin-bottom: 20px;\r\n}\r\n\r\n/* Loading */\r\n.admin-loading {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: center;\r\n  height: 100vh;\r\n  font-size: 18px;\r\n  color: #666;\r\n}\r\n\r\n/* Responsive */\r\n@media (max-width: 768px) {\r\n  .stats-grid {\r\n    grid-template-columns: repeat(2, 1fr);\r\n  }\r\n\r\n  .charts-row {\r\n    grid-template-columns: 1fr;\r\n  }\r\n\r\n  .bar-chart {\r\n    height: 150px;\r\n  }\r\n\r\n  .bar-container {\r\n    width: 20px;\r\n    height: 100px;\r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {};
export default ___CSS_LOADER_EXPORT___;
